let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dzp9v")).then(() => parcelRequire('u4lEZ'));